import { MOBILE_SCREEN_BREAKPOINT_HEIGHT, MOBILE_SCREEN_BREAKPOINT_WIDTH } from '../models/common-constants';

export const mobileDevices = `@media (max-width: ${ MOBILE_SCREEN_BREAKPOINT_WIDTH }px)`;
export const mobileDevicesLandscape = `@media (max-width: ${ MOBILE_SCREEN_BREAKPOINT_WIDTH }px) or (max-height: ${ MOBILE_SCREEN_BREAKPOINT_HEIGHT }px)`;
export const smallLaptops = '@media (max-width: 900px) or (max-height: 780px)';

// todo: define it
export const tablets = '?';
export const laptops = '@media (max-width: 900px)';
